var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "list-container f-column-b" }, [
        _c("div", { staticClass: "list-header" }, [
          _c("h3", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.title ? "搜索结果" : _vm.cateInfo.name)),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "info-list f-column-b" },
          [
            _vm.list.length
              ? _c(
                  "ul",
                  _vm._l(_vm.list, function (item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "info-item",
                        on: {
                          click: function ($event) {
                            return _vm.viewItem(item)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "point" }),
                        _c(
                          "span",
                          { staticClass: "flex-1 text-cut ml-20 title-txt" },
                          [_vm._v(_vm._s(item.title))]
                        ),
                        _c("span", { staticClass: "ml-40 color-999" }, [
                          _vm._v(_vm._s(item.releaseTime)),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _c("no-data"),
          ],
          1
        ),
      ]),
      _c("info-pagination", {
        attrs: {
          total: _vm.total,
          "current-page": _vm.curPage,
          "page-size": _vm.pageSize,
        },
        on: {
          "update:currentPage": function ($event) {
            _vm.curPage = $event
          },
          "update:current-page": function ($event) {
            _vm.curPage = $event
          },
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }